import React from 'react'

const Saree = () => {
    return (
        <div>Saree</div>
    )
}

export default Saree